<template>
  <button
    class="group flex items-center justify-center rounded p-1 pr-0-5 hover:bg-grey-hover"
    data-cy="pin-button"
    @click.stop="agentSessionInfo.isPinned = !agentSessionInfo.isPinned"
  >
    <icon-base
      :icon="IconPinSecondary"
      :class="{ 'text-headline': agentSessionInfo.isPinned }"
    />
  </button>
</template>
<script setup lang="ts">
import { storeToRefs } from "pinia";

import { useAiAgentsStore } from "@/stores/ai/agents";

import IconPinSecondary from "@/components/icons/IconPinSecondary.vue";
import IconBase from "@/components/ui/IconBase.vue";

const { agentSessionInfo } = storeToRefs(useAiAgentsStore());
</script>
